module.exports = __webpack_public_path__ + "img/iconos-ilustracion-07.ac3ed2aa.jpg";